import React from 'react';
import { motion } from 'framer-motion';
import { UserPlus, Compass, Zap } from 'lucide-react';
export const HowItWorks: React.FC = () => {
  const steps = [{
    icon: UserPlus,
    title: 'Sign Up',
    description: 'Create your free Billvast account in minutes.'
  }, {
    icon: Compass,
    title: 'Explore',
    description: 'Access all four pillars from one unified dashboard.'
  }, {
    icon: Zap,
    title: 'Transact',
    description: 'Send, pay, raise, and manage with absolute ease.'
  }];
  return <section id="how-it-works" className="py-24 bg-white overflow-hidden" data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-brand-text-dark mb-4" data-id="element-122">
            How It Works
          </motion.h2>
          <p className="text-lg text-brand-text-light" data-id="element-123">
            Three simple steps to financial freedom.
          </p>
        </div>

        <div className="relative" data-id="element-124">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gray-100" data-id="element-125" />

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-126">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="text-center" data-id="element-127">
                <div className="w-24 h-24 mx-auto bg-white border-4 border-gray-50 rounded-full flex items-center justify-center shadow-xl shadow-brand-primary/5 mb-6 relative" data-id="element-128">
                  <div className="absolute inset-0 rounded-full bg-brand-primary/10 animate-pulse" data-id="element-129" />
                  <step.icon size={32} className="text-brand-primary relative z-10" data-id="element-130" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-brand-text-dark text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-131">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-brand-text-dark mb-3" data-id="element-132">
                  {step.title}
                </h3>
                <p className="text-brand-text-light" data-id="element-133">{step.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};